// theme
import palette from "../theme/palette";
import tinycolor from "tinycolor2";
// ----------------------------------------------------------------------

// helper to generate consistent hash for a string (like alphabet)
function hashString(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return hash;
}

export function randomColorFromAlphabet(letter) {
  // create a hash from the letter
  const hash = hashString(letter.toLowerCase());

  // map hash → hue (0–360)
  const hue = Math.abs(hash) % 360;

  // create color with fixed saturation/lightness so it looks good
  return tinycolor({ h: hue, s: 0.6, l: 0.5 }).toHexString();
}
export const colorPresets = [
  // DEFAULT
  {
    name: "default",
    ...palette.light.primary,
  },
  // PURPLE
  {
    name: "purple",
    lighter: "#EBD6FD",
    light: "#B985F4",
    main: "#7635dc",
    dark: "#431A9E",
    darker: "#200A69",
    contrastText: "#fff",
  },
  // CYAN
  {
    name: "cyan",
    lighter: "#D1FFFC",
    light: "#76F2FF",
    main: "#1CCAFF",
    dark: "#0E77B7",
    darker: "#053D7A",
    contrastText: palette.light.grey[800],
  },
  // BLUE
  {
    name: "blue",
    lighter: "#D1E9FC",
    light: "#76B0F1",
    main: "#2065D1",
    dark: "#103996",
    darker: "#061B64",
    contrastText: "#fff",
  },
  // ORANGE
  {
    name: "orange",
    lighter: "#FEF4D4",
    light: "#FED680",
    main: "#fda92d",
    dark: "#B66816",
    darker: "#793908",
    contrastText: palette.light.grey[800],
  },
  // RED
  {
    name: "red",
    lighter: "#FFE3D5",
    light: "#FFC1AC",
    main: "#FF3030",
    dark: "#B71833",
    darker: "#7A0930",
    contrastText: "#fff",
  },
];

export const defaultPreset = colorPresets[0];
export const purplePreset = colorPresets[1];
export const cyanPreset = colorPresets[2];
export const bluePreset = colorPresets[3];
export const orangePreset = colorPresets[4];
export const redPreset = colorPresets[5];
const createColorObject = (color) => {
  if (color === "default" || !tinycolor(color).isValid()) {
    return {
      light: "#5A0A45",
      lighter: "#5A0A45",
      main: "#5A0A45",
      dark: "#370525",
      darker: "#2C0320",
      name: "default",
      contrastText: "#fff",
    };
  }
  return {
    name: tinycolor(color).toName() ? tinycolor(color).toName() : color,
    main: color,
    lighter: tinycolor(color).lighten(20).toHexString(),
    light: tinycolor(color).lighten().toHexString(),
    dark: tinycolor(color).darken().toHexString(),
    darker: tinycolor(color).darken(20).toHexString(),
    contrastText: tinycolor(color).isLight() ? "#000" : "#fff",
  };
};
export default function getColorPresets(presetsKey) {
  const color = presetsKey;

  return createColorObject(color);
}
